import React from 'react'
import { GiftCardPaymentOption, SalePayment } from './types'

type Props = {
  paymentOptions: GiftCardPaymentOption
  onSuccess?: (result: SalePayment) => void
  onClose: () => void
}

export const GiftCard = ({ paymentOptions, onSuccess, onClose }: Props) => {
  // Placeholder for the actual implementation
  // Get the rest of the missing data from redux and manager
  return <></>
}
